import TableActionHeader from 'components/Global/TableActionHeader';

export const Dashboard = () => {
	return (
		<div>
			<TableActionHeader></TableActionHeader>
		</div>
	);
};
